import axios from "axios";
import axiosRetry from "axios-retry";
import Cookie from "../utils/cookie";
import publicUtils from "./index";
import commonJs from "../assets/js/common/common.js";

import {
  queryParams,
  goLogin,
  // errTips,
  // getQueryString
} from "@/utils/tools";
import CRC32 from "crc-32";

const baseUrl = process.env.VUE_APP_BASEURL;
const appId = process.env.VUE_APP_APPID;

/**
 * 京东 图片系统 上传
 */
export function uploadFile(file, onUploadProgress) {
  const promise = new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsBinaryString(file);
    reader.onload = async (event) => {
      const crc = CRC32.bstr(event.target.result);
      const keycode = `${crc.toString(16)}${file.size}_`;
      axios({
        method: "POST",
        url: "/imageUpload.action",
        data: file,
        headers: {
          "content-type": file.type,
          keycode: keycode,
        },
        onUploadProgress: onUploadProgress,
      })
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    };
  });

  return promise;
}

class HttpRequest {
  constructor(baseUrl, appId) {
    this.baseUrl = baseUrl;
    this.appId = appId;
    this.queue = {};
  }

  getInsideConfig() {
    const config = {
      baseURL: this.baseUrl,
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
      timeout: 6000,
      withCredentials: true,
    };
    return config;
  }

  destroy(url) {
    delete this.queue[url];
    if (!Object.keys(this.queue).length) {
      // Spin.hide()
    }
  }

  interceptors(instance, url) {
    // 请求拦截
    instance.interceptors.request.use(
      (config) => {
        // var ticket = Cookie.getCookie("sso.jd.com");
        // Cookie.setCookie("ticket", ticket);
        this.queue[url] = true;
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );

    /*CONTENT_TENANT_IS_INVALID("1401","租户已失效"),
    CONTENT_TENANT_MANAGER_IS_INVALID("1409","租户管理员已被冻结"),
    CREATOR_ACCOUNT_STATUS_ERROR("2402","创作者账户审核状态错误"),
    CREATOR_ACCOUNT_AUDIT_STATUS_ERROR("2403","创作者账户审核状态错误"),*/
    // 响应拦截
    instance.interceptors.response.use(
      (res) => {
        this.destroy(url);
        let { data: result } = res;
        if (window.location.pathname != "/logo" && result.code === "1023") {
          // 未登录
          goLogin(); // 跳转到登录页
          return false;
        } else if (
          result.code === "0000" ||
          result.code === "0" ||
          result.success === true
        ) {
          // 请求成功
          return result.data || result;
        } else if (
          ["3300", "3301", "3302", "3303", "3304"].indexOf(result.code) > -1
        ) {
          return result;
        } else if (
          [
            40004, // 无权限访问菜单
            40005, // 无登录态
            40006, // 鉴权失败
            "1400", // 租户不存在
            "1406", // 运营不存在
            "1401", // 租户已失效
            "1409", // 租户管理员状态无效
            "2406", // 创作者账号已冻结
            "2407", // 创作者审核被驳回
          ].indexOf(result.code) > -1
        ) {
          publicUtils.account_type_error(result.code);
          return Promise.reject(result);
        } else if (result.code === "1500") {
          // 没有权限 TODO
          return Promise.reject(result);
        } else if (result.code === "-1") {
          // 后台请求接口不通 TODO
          return Promise.reject(result);
        } else {
          // 请求失败
          return Promise.reject(result);
        }
      },
      (error) => {
        this.destroy(url);
        return Promise.reject(error);
      }
    );
  }

  request(options) {
    const instance = axios.create();
    // 请求失败重新请求
    axiosRetry(instance, {
      retries: 4, // 重新请求四次
      retryDelay: (retryCount) => {
        // 重新请求延迟
        return retryCount * 1000;
      },
    });
    var tenantId = commonJs.getQueryString("tenantId");
    var erpOrJdpin = window.sessionStorage.getItem("logintype");
    var functionId = options.data.functionId;
    options = Object.assign(this.getInsideConfig(), options);
    options.params && this.appId && (options.params.appid = this.appId);
    options.params && (options.params._t = new Date().getTime());
    // 只有MAN端的用户使用ERP,写手端只有JDPIN账号
    options.params &&
      (options.params.loginType =
        (process.env.VUE_APP_TYPE == "man" ||
          process.env.VUE_APP_TYPE == "admin") &&
        erpOrJdpin == "erp"
          ? 7
          : 3);
    options.params && (options.params.tenantId = tenantId);

    options.data && this.appId && (options.data.appid = this.appId);
    options.data &&
      options.data.body &&
      options.data.body.appid &&
      (options.data.appid = options.data.body.appid);
    options.data &&
      options.data.body &&
      options.data.body.appid &&
      delete options.data.body.appid;
    options.data && (options.data._t = new Date().getTime());
    // 只有MAN端的用户使用ERP,写手端只有JDPIN账号
    options.data &&
      (options.data.loginType =
        (process.env.VUE_APP_TYPE == "man" ||
          process.env.VUE_APP_TYPE == "admin") &&
        erpOrJdpin == "erp"
          ? 7
          : 3);
    options.data && (options.data.tenantId = tenantId);

    // options.data && options.data.body && (options.data.body.channelId=sessionStorage.getItem("channelId")||process.env.CHANNELID)//渠道ID
    // options.data && options.data.body && (options.data.body.tenantAppId=sessionStorage.getItem("tenantAppId")||null)//租户所属应用id
    // options.data && options.data.body && (options.data.body.tenantUnid=sessionStorage.getItem("tenantUnid")||null)//租户唯一标识

    options.data && (options.data = queryParams(options.data));
    options.baseURL = `${options.baseURL}/${functionId}`;
    this.interceptors(instance, options.url);
    return instance(options);
  }
}

const httpRequest = new HttpRequest(baseUrl, appId);

export default httpRequest;

export const request = (functionId, body, appId) => {
  let data = {
    functionId,
    body,
  };
  return httpRequest.request({
    data: data,
    method: "post",
  });
};
